// extracted by mini-css-extract-plugin
export default {"helpStepContainer":"HowItWorksPage_helpStepContainer__534DA","imageContainer":"HowItWorksPage_imageContainer__a98AP"};